<ngx-spinner></ngx-spinner>
<section>
  <div class="row" *ngIf="showAlertMessage">
      <div class="col-md-1"></div>
      <div class="col-md-10">
          <div class="card p-p-2"
              style="border-left-color: red;border-left-style: solid;border-left-width: 5px;border-right-color: red;border-right-style: solid; border-right-width: 5px;">
              <span class="text-nomal text-danger p-text-center">{{alertMessage}}</span>
             
          </div>
         
      </div>
      <div class="col-md-1"></div>
  </div>
</section>
<!---------------Info Box Start-------------->
<!---------------Info Box Start-------------->

<section>
<div class="p-p-5 p-mb-6" style="margin-left: -16px;margin-top: -5px;margin-right: -16px;background-color: #2884b8;background-image: linear-gradient(315deg, #2884b8 0%, #6b376d 74%);">
  <div class="row row-cards">
    <div class="p-col">
      <div class="card card-sm" style="border-radius:8px;background-color: #7f5a83;background-image: linear-gradient(315deg, #7f5a83 0%, #0d324d 74%);">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-auto">
              <span class="text-white avatar">
                <span><i class="fas fa-user" style="font-size: 2rem;color: white;"></i></span>
              </span>
            </div>
            <div class="col">
              <div class="font-weight-medium">
                <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue; font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Applicants</span>
              </div>
              <!-- <div class="text-muted"> </div> -->
            </div>
          </div> <hr>       
          <div class="row">
            <div class="col-6">
              <span class="text-white">
                <span class=" align-items-left">Available</span>
              </span>
            </div>
          
            <div class="col-6" style="text-align: right;">
              <p-badge [value]="dashboardCount.applicantsAvailable"></p-badge>
            </div>
          
          </div> <br>
          <div class="row">
            <div class="col-6">
              <span class="text-white avatar">
                <span class="align-items-right" style="font-size:15px;">Not-Available</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
              <p-badge [value]="dashboardCount.applicantsNotAvailable"></p-badge>
            </div>
          </div><br><br>
        </div>
      </div>
    </div>

    <div class="p-col">
      <div class="card card-sm" style="border-radius:8px;background-color: #7f5a83;background-image: linear-gradient(315deg, #7f5a83 0%, #0d324d 74%);">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-auto">
              <span class="text-white avatar">
                <span><i class="fas fa-briefcase" style="font-size: 2rem;color: white;"></i></span>
              </span>
            </div>
            <div class="col">
              <div class="font-weight-medium">
            <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Requisitions</span>                
              </div>
            </div>
          </div><hr>
          <div class="row">
            <div class="col-6">
             <span class="text-white">
               <span class="align-items-left">Open</span>
             </span>
            </div>
            <div class="col-6" style="text-align: right;">
             <span class="text-white">
               <p-badge [value]="dashboardCount.requisitionOpenTotal" ></p-badge>
             </span>
            </div>
           </div><br>
           <div class="row">
             <div class="col-6">
               <span class="text-white">
                 <span class=" align-items-center">Active</span>
               </span>
             </div>
             <div class="col-6" style="text-align: right;">
               <span class="text-white">
                  <p-badge [value]="dashboardCount.requisitionActiveTotal" ></p-badge>
               </span>
             </div>
            </div> <br>
            <div class="row">
             <div class="col-6">
               <span class="text-white avatar">
                 <span class=" align-items-right" style="font-size: 15.5px;">Submissions</span>
               </span>
             </div>
             <div class="col-6" style="text-align: right;">
               <span class="text-white avatar">
                 <p-badge [value]="dashboardCount.submittedApplicants"></p-badge>
               </span>
             </div>
            </div>

        </div>
      </div>
    </div>
  
    <div class="p-col">
      <div class="card card-sm" style="border-radius:8px;background-color: #2a2a72;background-image: linear-gradient(315deg, #2a2a72 0%, #009ffd 74%);">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-auto">
              <span class="text-white avatar">
                <span><i class="fas fa-user-edit" style="font-size: 2rem;color: white;"></i></span>
              </span>
            </div>
            <div class="col">
              <div class="font-weight-medium">
            <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Interviews</span>                
              </div>
            </div>
          </div><hr>
          <div class="row">
            <div class="col-6">
              <span class="text-white">
                <span class=" align-items-left">Scheduled</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
              <span class="text-white">
                <p-badge [value]="dashboardCount.scheduledInterviews" ></p-badge>
              </span>
            </div>
          </div><br>
          <div class="row">
            <div class="col-6">
              <span class="text-white">
                <span class=" align-items-center" style="font-size: 15px;">Rescheduled</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
              <span class="text-white">
                <p-badge [value]="dashboardCount.reScheduledInterviews" ></p-badge>
              </span>
            </div>
          </div><br>
          <div class="row">
          <div class="col-6">
            <span class="text-white avatar">
              <span class=" align-items-right">Accepted</span>
            </span>
          </div>
          <div class="col-6" style="text-align: right;">
            <span class="text-white avatar">
              <p-badge [value]="dashboardCount.acceptedInterviews" ></p-badge>
            </span>
          </div>
        </div>

        </div>
      </div>
    </div>

    <div class="p-col">
      <div class="card card-sm" style="border-radius:8px;background-color: #2a2a72;background-image: linear-gradient(315deg, #2a2a72 0%, #009ffd 74%);">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-auto">
              <span class="text-white avatar">
                <span class="text-left"><i class="fas fa-handshake" style="font-size: 2rem;color: white;"></i></span>
              </span>              
            </div>
            <div class="col">
              <div class="font-weight-medium">
            <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px blue;font-size: 1.3rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Engagements</span>
                
              </div>
            </div>
          </div><hr>
          <div class="row">
            <div class="col-6">
              <span class="text-white">
                <span class=" align-items-left">Initiated</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
             <p-badge [value]="dashboardCount.offerInitiated"></p-badge>
            </div>
          </div><br>
          <div class="row">
            <div class="col-6">
              <span class="text-white avatar">
                <span class=" align-items-center">Negotiated</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
             <p-badge [value]="dashboardCount.offerNegotiated"></p-badge>
            </div>
          </div><br>
          <div class="row">
            <div class="col-6">
              <span class="text-white avatar">
                <span class=" align-items-right">Accepted</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
              <p-badge [value]="dashboardCount.offerAccepted"></p-badge>   
            </div>
          </div>
        </div>
      </div>
    </div>   
    <div class="p-col">
      <div class="card card-sm" style="border-radius:8px;background-color: #30999c;background-image: linear-gradient(315deg, #2a2a72 0%, #5394b9 74%);">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-auto">
              <span class="text-white avatar">
                <span class="text-left"><i class="fas fa-file-invoice-dollar" style="font-size: 2rem;color: white;"></i></span>
              </span>              
            </div>
            <div class="col">
              <div class="font-weight-medium">
            <span style="text-shadow: 1px 1px 1px #000,3px 3px 5px rgb(32, 86, 138);font-size: 1.5rem;color: white;font-weight: 700;font-family: Roboto,'system-ui',sans-serif;" class="float-right">Invoices</span>
                
              </div>
            </div>
          </div><hr>
          <div class="row">
            <div class="col-6">
              <span class="text-white">
                <span class=" align-items-left">Approved</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
              <p-badge [value]="dashboardCount.invoiceApproved" ></p-badge>
            </div>
          </div><br>
          <div class="row">
            <div class="col-6">
              <span class="text-white avatar">
                <span class=" align-items-center">Rejected</span>
              </span>
            </div>
            <div class="col-6" style="text-align: right;">
              <p-badge [value]="dashboardCount.invoiceRejected"></p-badge>   
            </div>
          </div><br>
          <div class="row">
            <div class="col-9">
              <span class="text-white avatar">
                <span class="align-items-left" style="font-size:15px;">Payment On-Hold</span>
              </span>
            </div>
            <div class="col-3" style="text-align: right;">
              <p-badge [value]="dashboardCount.invoicePaymentonHold"></p-badge> 
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-4">
              <span class="text-white">
                <span class=" align-items-left">Approved</span>
              </span>
            </div>
            <div class="col-4">
              <span class="text-white avatar">
                <span class=" align-items-center">Rejected</span>
              </span>
            </div>
            <div class="col-4">
              <span class="text-white avatar">
                <span class="align-items-left">Payment On-Hold</span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <p-badge [value]="dashboardCount.invoiceApproved" ></p-badge>
            </div>
            <div class="col-4">
              <p-badge [value]="dashboardCount.invoiceRejected"></p-badge>              
            </div>
            <div class="col-4">
              <p-badge [value]="dashboardCount.invoicePaymentonHold"></p-badge>              
            </div>
          </div> -->
        </div>
      </div>
    </div>  
  
  </div>
  <br>
</div>
</section>

<!---------------Info Box End-------------->
<!---------------Info Box End-------------->

<!---------------Aler Message Box start-------------->

<section>
  <div class="row">
      <div class="col-md-12">
          <div class="card p-p-3"
              style="margin-top: -91px;margin-bottom: 100px;border-left-color: red;border-left-style: solid;border-left-width: 8px;border-right-color: red;border-right-style: solid; border-right-width: 8px;">
              
              
                    <span class="text-nomal text-danger p-text-center" style="color: #009ffd !important;cursor: pointer;"><a
                          [routerLink]="" (click)="editCompany()">Click here to update the onboarding documents </a> </span>
                  
                  
              
            </div>
      </div>
  </div>
</section>  

<section *ngIf="alertMsg && !showCompanyInsuranceExpiryMessage">
<div class="card p-p-5" style="margin-top: -91px;margin-bottom: 100px;">
  <!-- <marquee onMouseOver="this.stop()" onMouseOut="this.start()">
    <span class="p-text-normal" style="font-family: roboto,'system-ui',sans-serif;color: #f5071e;">The following insurance(s) is going to expire in your system -
      <span class="text-sm" *ngIf="isEnable" style="text-decoration: underline;cursor: pointer;color: #009ffd;"><span  class="table-col-view"><a [routerLink]=""  (click)="editCompany()">{{expirymessage}}</a></span></span>
      <span class="text-sm" *ngIf="!isEnable" style="text-decoration: underline;color: #009ffd;"><span  class="table-col-view">{{expirymessage}}</span></span>
    <span class="p-text-normal" style="font-family: roboto,'system-ui',sans-serif;color: #f5071e;">.&nbsp;You can update the insurance(s) by clicking on the insurance name.</span>
   </span>
  </marquee>  -->
  <!-- <marquee onMouseOver="this.stop()" onMouseOut="this.start()">
    <span class="p-text-normal" style="font-family: roboto,'system-ui',sans-serif;color: #f5071e;">The following insurance(s) is going to expire in your system -
      <span class="text-sm" *ngIf="isEnable" style="color: #009ffd;"><span  class="table-col-view">{{expirymessage}}.</span></span>
      <span class="text-sm" *ngIf="!isEnable" style="text-decoration: underline;color: #009ffd;"><span  class="table-col-view">{{expirymessage}}</span></span>
    <span class="p-text-normal" style="font-family: roboto,'system-ui',sans-serif;color: #f5071e;">&nbsp;Kindly email the renewed COI to invoiceteam@devcare.com.</span>
   </span>
  </marquee>  -->
  <marquee onMouseOver="this.stop()" onMouseOut="this.start()">
    <span class="p-text-normal" style="font-family: roboto,'system-ui',sans-serif;color: #f5071e;">The following insurance(s) is going to expire in your system -
      <span class="text-sm" *ngIf="isEnable" style="text-decoration: underline;cursor: pointer;color: #009ffd;"><span  class="table-col-view"><a [routerLink]=""  (click)="editCompany()">{{expirymessage}}</a></span></span>
      <span class="text-sm" *ngIf="!isEnable" style="text-decoration: underline;color: #009ffd;"><span  class="table-col-view">{{expirymessage}}</span></span>
    <span class="p-text-normal" style="font-family: roboto,'system-ui',sans-serif;color: #f5071e;">.&nbsp;You can update
      your insurance(s) by clicking on the insurance name and open the Certificate of Insurance sub-section under Onboarding
      Documents / Client Selection section.</span>
   </span>
  </marquee> 
</div>
</section>
<section>
  <div class="row" *ngIf="showCompanyInsuranceExpiryMessage">
      <!-- <div class="col-md-1"></div> -->
      <div>
          <div class="card p-p-3"
              style="margin-top: -91px;margin-bottom: 100px;border-left-color: red;border-left-style: solid;border-left-width: 8px;border-right-color: red;border-right-style: solid; border-right-width: 8px;">
              <marquee onMouseOver="this.stop()" onMouseOut="this.start()">
              <span class="text-nomal text-danger p-text-center"><strong>You are receiving this alert because the following
                  insurance(s) - </strong> <span *ngIf="isEnable" style="color: #009ffd !important;cursor: pointer;"><a
                          [routerLink]="" (click)="editCompany()">{{expiredInsurance}} </a> </span>
                  <span *ngIf="!isEnable" style="color: #009ffd !important;">{{expiredInsurance}}</span>
                  <strong>has expired in your system. </strong></span>
              <span class="text-nomal text-danger  p-text-center"><strong>Only after the insurance(s) have been updated will the payments be processed. To avoid payment delays, kindly update your insurance(s).</strong></span>
            </marquee>
            <!-- <marquee onMouseOver="this.stop()" onMouseOut="this.start()">
              <span class="text-nomal text-danger p-text-center"><strong>You are receiving this alert because the following
                  insurance(s) - </strong> <span *ngIf="isEnable" style="color: #009ffd !important;">{{expiredInsurance}} </span>
                  <span *ngIf="!isEnable" style="color: #009ffd !important;">{{expiredInsurance}}</span>
                  <strong>has expired in your system. </strong></span>
              <span class="text-nomal text-danger  p-text-center"><strong>Only after the insurance(s) have been updated will the payments be processed. To avoid payment delays, kindly email the renewed COI to invoiceteam@devcare.com.</strong></span>
            </marquee> -->
            </div>
      </div>
      <!-- <div class="col-md-1"></div> -->
  </div>
</section>  
<section>
  <div class="row" *ngIf="!showDocumentPendingNotificationMessage">
      <div>
          <div class="card p-p-3"
              style="margin-top: -91px;margin-bottom: 100px;border-left-color: red;border-left-style: solid;border-left-width: 8px;border-right-color: red;border-right-style: solid; border-right-width: 8px;">
              
              <span class="text-nomal text-danger p-text-center">One or more documents have been rejected or the upload is pending. All the requested documents must be uploaded before you can begin submitting the invoices. Please upload the documents from your 
                    <span  style="color: #009ffd !important;cursor: pointer;"><a
                          [routerLink]="" (click)="editCompany()">Company Profile - Edit Page - Onboarding Documents section </a> </span>
                  
                  and contact <strong>invoiceteam@devcare.com</strong> with any questions. </span>
              
            </div>
      </div>
  </div>
</section>  
<!---------------Aler Message Box End-------------->


<!---------------MyTask start-------------->
<!---------------MyTask start-------------->

<section style="margin-top: -80px;">
<div class="p-card p-p-3">
 <div class="p-card-header">
   <span class="p-text-bold">My Tasks <p-badge [value]="tasksCount" styleClass="p-ml-1"></p-badge></span>
 </div>
 <div class="">
  <p-table [value]="tasksList" [rows]="10" [showCurrentPageReport]="true" [resizableColumns]="false"
  [rowsPerPageOptions]="[10,25,50]" [loading]="null" styleClass="p-datatable" [paginator]="false"
  class="w-100">

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 20rem"></th>
      <th style="width: 4rem"></th>
    </tr>

  </ng-template>
  <ng-template pTemplate="body" let-task>
    <tr>
      <td>
        <span class="table-col-view"><a [routerLink]="" (click)="viewTask(task.applicantReferenceId,task.submissionReferenceId)">{{task.taskTitle}}</a></span>
        <br/>
        <span class="customer-badge" [ngClass]="{
          'status-active': task.taskSubTitle == 'Interview',
          'status-offer-initiated': task.taskSubTitle == 'Engagement'

        }">{{task.taskSubTitle}}</span>
      </td>
      <td><span style="border-radius: 5px;padding: 5px;background: aliceblue;">{{task.createdOn | date:'MMM dd, yyyy'}}</span></td>
    </tr>

  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">Sorry, no tasks found.</td>
    </tr>
  </ng-template>
</p-table>
 </div>
 <p-dialog  header="Confidentiality Disclaimer" class="desclaimer-dialog"  [modal]="true" [style]="{width: '50vw', height: 'auto'}" [maximizable]="false" [closable]="false"
[draggable]="false" [resizable]="false" [(visible)]="isFirstTimeVisiable">
    <div class="p-fluid">
     
      <div class="text-center">
        <span style="font-family: Roboto,'system-ui',sans-serif;">The content in D-VMS is confidential and intended for the registered company only. Sharing any D-VMS system information with a third party is strictly forbidden. Any violation of this agreement will be a breach of contract and will result in immediate deactivation from the D-VMS</span>
      </div>
      <div class="text-center">
        <strong><a [routerLink]="['/terms-and-conditions']" target="_blank">Terms & Conditions</a></strong>
      </div>
      <br>
      <div class="text-center p-mt-2">
        <button pButton pRipple type="button"  (click)="cancelFirstTimeVisiableDialog()"  [style]="{'width':'100px','height':'30px'}" icon="pi pi-check-circle" label="Ok"
        class="p-button-sm p-button-info"></button>
      </div>
      </div>
</p-dialog>
</div>

</section>
<!---------------MyTask End-------------->
<!---------------MyTask End-------------->
